import { TERM_MAP } from './cryptoTerms';

/**
 * Splits a plain-text line into segments: { text, canonical? }
 * Segments with a canonical are clickable terms; others are plain text.
 */
export function detectTerms(line) {
  if (!line || !line.trim()) return [{ text: line }];

  // Build one big alternation regex, escaped, longest-first
  const escaped = TERM_MAP.map(t =>
    t.surfaceForm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );
  const regex = new RegExp(`(${escaped.join('|')})`, 'gi');

  const segments = [];
  let lastIdx = 0;
  let match;

  // Reset regex
  regex.lastIndex = 0;

  while ((match = regex.exec(line)) !== null) {
    const [found] = match;
    const start = match.index;

    if (start > lastIdx) {
      segments.push({ text: line.slice(lastIdx, start) });
    }

    // Find canonical for matched surface form
    const entry = TERM_MAP.find(
      t => t.surfaceForm.toLowerCase() === found.toLowerCase()
    );
    segments.push({ text: found, canonical: entry?.canonical });
    lastIdx = start + found.length;
  }

  if (lastIdx < line.length) {
    segments.push({ text: line.slice(lastIdx) });
  }

  return segments.length ? segments : [{ text: line }];
}
